import React, {Component} from 'react';
import './ViewSingleCustomerOrder.css';

import {FormattedMessage} from "react-intl";
import CustomerOrderItemTable from "../CustomerOrderItemTable/CustomerOrderItemTable";
import axios from "axios";
import {GOOGLE_ANALYTICS_CODE, RESOURCE_BASE_URL} from "../../../../configuration";
import NumberFormatter from "../../../Common/NumberFormatter/NumberFormatter";
import {Link} from "react-router-dom";
import ReactGA from "react-ga";

class ViewSingleCustomerOrder extends Component {
    constructor(props) {
        super(props);
        this.state = {
            orderData: [],
            orderItems: [],
            userInfo: [],
            orderId: this.props.match.params.id,
            billOrderInfo: [],
            shipOrderInfo: [],
            orderTotal : 0,
            user : null,
            paymentDate: '',
            amount: '',
            refId: '',
            paymentMethod: ''
        };
        this.getUserForOrderData = this.getUserForOrderData.bind(this);
        this.getOrder = this.getOrder.bind(this);
    }

    componentDidMount() {
        this.getOrder();
    }

    getOrder = () => {

        axios.get(RESOURCE_BASE_URL + 'api/orders/order/' + this.state.orderId)
            .then((res) => {
                this.setState({
                    orderData: res.data.order,
                    userInfo: res.data.order.userInfo,
                    orderItems: res.data.order.orderItems,
                    billOrderInfo: res.data.order.orderInfo.billingAddress,
                    shipOrderInfo: res.data.order.orderInfo.shippingAddress,
                    orderTotal : res.data.orderSummary.orderTotal,
                    paymentDate: res.data.order.payment.createdOn,
                    refId: res.data.order.payment.paymentId,
                    paymentMethod: res.data.order.payment.paymentMethod
                }, ()=> this.getUserForOrderData(res.data.order.id));
                // console.log("SINGLE ORDER DUO ====> ",res.data);
                // console.log("no", this.state.orderId);
                // console.log("ord", this.state.orderData);

            })
            .catch((err) => {
                console.log("[API] ERROR: ", err);

            });
    };

    getUserForOrderData = (orderId) => {
        axios.get(RESOURCE_BASE_URL + 'api/userdata/' + orderId)
            .then((res) => {
                this.setState({
                    user : res.data
                });
            })
            .catch((err) => {
                console.log("[API] ERROR: ", err);

            });
    };
    getPayment = () => {
        axios.get(RESOURCE_BASE_URL + 'api/sales/payment/' + this.state.orderId)
            .then((res) => {
                this.setState({
                    paymentDate: res.data.createdOn,
                    amount: res.data.amount,
                    refId: res.data.paymentId
                });
                // console.log(res.data);
                // console.log("paymentDatya", res.data.createdOn)

            })
            .catch((err) => {
                console.log("[API] ERROR: ", err);

            });

    };
    render() {
        ReactGA.initialize(GOOGLE_ANALYTICS_CODE);
        ReactGA.pageview(window.location.pathname + window.location.search);

        let orderTotalFromChargeDetails=0.0;
        let shippedStringDate = this.state.orderData.shippedDate;
        return (
            <div className="admin-view-single-order-content">
                <div className="admin-view-single-order-div">
                    <div className="title-1">
                        <FormattedMessage id="app.admin.order.view.single.title"
                                          defaultMessage="ORDER "
                                          description=""/>&nbsp;
                        <span>#{this.state.orderData.batchNumber}</span>
                        <hr className="no-padding"/>
                    </div>

                    <div className="row">
                        <div className="row">
                            <div className="col-md-4">
                                <div className="view-details-header-div">
                                    <label className="admin-admin-view-single-order-label">
                                        <FormattedMessage id="app.admin.view.single.customer.info"
                                                          defaultMessage="Customer Information "
                                                          description=""/>
                                    </label>
                                </div>
                                <div>
                                    <label className="view-details-body-label">
                                        ユーザー名
                                        :&nbsp; </label>
                                    {this.state.user !== null ? this.state.user.userName :
                                        <FormattedMessage id="app.order.all.no-records" defaultMessage="No Records Found" description=""/>}
                                </div>
                                <div>
                                    <label className="view-details-body-label">
                                        <FormattedMessage id="app.user-profile.user-profile-info.name"
                                                          defaultMessage="Name"
                                                          description=""/>:&nbsp; </label>
                                    {this.state.user !== null ? this.state.user.firstName +" " +this.state.user.lastName :
                                        <FormattedMessage id="app.order.all.no-records" defaultMessage="No Records Found" description=""/>}
                                </div>
                                <div>
                                    <label className="view-details-body-label">
                                        <FormattedMessage id="app.user-profile.user-profile-info.email"
                                                          defaultMessage="Email"
                                                          description=""/>:&nbsp; </label>
                                    {this.state.user !== null ? this.state.user.email :
                                        <FormattedMessage id="app.order.all.no-records"
                                                          defaultMessage="No Records Found" description=""/>}
                                </div>
                                <div>
                                    <label className="view-details-body-label">
                                        <FormattedMessage id="app.user-profile.user-profile-info.phone"
                                                          defaultMessage="Phone"
                                                          description=""/>:&nbsp; </label>
                                    {this.state.user !== null ? this.state.user.contactNumber.number :
                                        <FormattedMessage id="app.order.all.no-records"
                                                          defaultMessage="No Records Found" description=""/>}
                                </div>


                            </div>
                            <div className="col-md-4">
                                <div className="view-details-header-div">
                                    <label className="admin-view-single-order-label">
                                        <FormattedMessage id="app.admin.order.single.billing.address"
                                                          defaultMessage="Billing Address "
                                                          description=""/>
                                    </label>
                                </div>

                                <div>{this.state.billOrderInfo.lastName}&nbsp; {this.state.billOrderInfo.firstName}</div>
                                <div>{this.state.billOrderInfo.postalCode}</div>
                                <div>{this.state.billOrderInfo.province}&nbsp;{this.state.billOrderInfo.city}</div>
                                <div>{this.state.billOrderInfo.streetAddress}</div>
                                <div>{this.state.billOrderInfo.addressLine2}</div>
                                {/*<div>{this.state.billOrderInfo.country === "jp" ? "日本" : this.state.billOrderInfo.country}</div>*/}
                                <div>{this.state.billOrderInfo.cellOrMobileNumber}</div>

                            </div>
                            <div className="col-md-4">
                                <div className="view-details-header-div">
                                    <label className="admin-view-single-order-label">
                                        <FormattedMessage id="app.admin.order.single.shipping.address"
                                                          defaultMessage="Shipping Address "
                                                          description=""/></label>
                                </div>

                                <div>{this.state.shipOrderInfo.lastName}&nbsp;{this.state.shipOrderInfo.firstName} </div>
                                <div>{this.state.shipOrderInfo.postalCode}</div>
                                <div>{this.state.shipOrderInfo.province}&nbsp;{this.state.shipOrderInfo.city}</div>
                                <div>{this.state.shipOrderInfo.streetAddress}</div>
                                <div>{this.state.shipOrderInfo.addressLine2} </div>
                                {/*<div>{this.state.shipOrderInfo.country === "jp" ? "日本" : this.state.shipOrderInfo.country}</div>*/}
                                <div>{this.state.shipOrderInfo.cellOrMobileNumber}</div>
                            </div>
                        </div>
                        <br/>

                    </div>
                    <hr/>
                    <div className="row">
                        <div className="col-md-6 resp-customer-order-dates">
                            <label className="admin-view-single-order-label">
                                <FormattedMessage id="app.admin.single.order.date"
                                                  defaultMessage="Order Date: "
                                                  description=""/>&nbsp;:&nbsp;
                            </label>
                            <span> {this.state.orderData.createdOn !== undefined ?
                                this.state.orderData.createdOn.substring(0,4)+"年"+
                                this.state.orderData.createdOn.substring(5,7)+"月"+
                                this.state.orderData.createdOn.substring(8,10)+"日" : ''}</span>
                            <br/>

                            <label className="admin-view-single-order-label">
                                <FormattedMessage id="app.admin.single.order.delivery.date"
                                                  defaultMessage="Delivery Date: "
                                                  description=""/>&nbsp;: &nbsp;
                            </label>
                            <span>{shippedStringDate && shippedStringDate !== null ?
                                shippedStringDate.substring(0, 4)+ "年" +
                                shippedStringDate.substring(5, 7)+ "月"+
                                shippedStringDate.substring(8, 10)+ "日"
                                :"生産中"}</span>
                            <br/>

                            <label className="admin-view-single-order-label">
                                <FormattedMessage id="app.admin.single.order.payment-date"
                                                  defaultMessage="Payment Date "
                                                  description=""/>&nbsp;:&nbsp;
                            </label>
                            <span>
                                {this.state.paymentDate.substring(0, 4)}年{this.state.paymentDate.substring(5, 7)}月{this.state.paymentDate.substring(8, 10)}日

                            </span>
                            <br/>
                            <label className="admin-view-single-order-label">
                                <FormattedMessage id="app.admin.single.ref-id"
                                                  defaultMessage="Reference Id "
                                                  description=""/>&nbsp;:&nbsp;
                            </label>
                            <span> {this.state.refId}</span>
                            <br/>
                            <label className="admin-view-single-order-label">
                                支払方法&nbsp;:&nbsp;
                            </label>
                            <span>{this.state.paymentMethod}</span>
                            <br/>
                        </div>
                        <div className="col-md-2"></div>
                        {this.state.orderItems.map(orderItems => {
                            let orderTotalJson=JSON.parse(orderItems.chargeDetails.priceInfoJson);
                            let total= orderTotalJson.total;
                            orderTotalFromChargeDetails=orderTotalFromChargeDetails+total;


                        })}
                        <div className="col-md-4 pull-right resp-customer-order-pull-left">
                            <div className="admin-single-order-total">
                                <FormattedMessage id="app.admin.single.order.bill.total"
                                                  defaultMessage="Bill Total"
                                                  description=""/> : &nbsp;
                                <span>
                                    ¥ <NumberFormatter num = {this.state.orderTotal}/>
                            </span>
                            </div>
                        </div>
                    </div>
                    <br/>

                    <div className="row">
                        <div className="col-md-12">
                            {/*<label className="admin-view-single-order-label">
                                <FormattedMessage id="app.admin.view.single.order.items"
                                                  defaultMessage="Items"
                                                  description=""/>
                            </label>*/}
                            <hr/>

                            <CustomerOrderItemTable orderData={this.state.orderItems} orderId={this.state.orderId}/>

                        </div>
                    </div>

                    <br/>

                </div>

            </div>
        )
    }

}

export default ViewSingleCustomerOrder;



// WEBPACK FOOTER //
// ./src/components/Admin/Order/ViewSingleCustomerOrder/ViewSingleCustomerOrder.js